export default "__VITE_ASSET__Cqn1Q7vm__"